import { getConfigData } from './config';

export function isEnvironment(env) {
  const config = getConfigData();
  return config.sentry_env === env;
}
